import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonDialog } from "../errors/ButtonDialog";
import { DialogContent } from "../errors/DialogContent";
export var DialogManualUpdate = function () {
    var onButtonClick = function () { return window.location.reload(true); };
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.iosManualUpdateDialog_title, className: IdStyles.ModalBackground },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            React.createElement(DialogContent, { messageLocaId: IdLoca.restartConfDialog_desc_web }),
            React.createElement(ButtonDialog, { onClick: onButtonClick }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/client-gateway/DialogManualUpdate.tsx
// module id = 2555
// module chunks = 3